const RESULT_STYLE = {
  WIN: "text-emerald-400",
  LOSS: "text-red-400",
  PUSH: "text-zinc-400",
  PENDING: "text-zinc-500",
};

const GROUPS = [
  { key: "full_game", label: "Full Game" },
  { key: "f5", label: "First 5", experimental: true },
  { key: "nrfi", label: "NRFI" },
  { key: "yrfi", label: "YRFI" },
];

const BucketGroup = ({ label, buckets, testId, experimental }) => (
  <div data-testid={testId} className="flex flex-col gap-2">
    <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wide text-zinc-500">
      {label}
      {experimental && (
        <span
          data-testid={`${testId}-experimental-badge`}
          className="rounded-full border border-amber-500/40 bg-amber-500/10 px-1.5 py-0.5 text-[9px] uppercase text-amber-400"
        >
          Experimental
        </span>
      )}
    </span>
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {buckets.map((b) => (
        <div key={b.label} data-testid={`${testId}-bucket-${b.label}`} className="rounded-lg border border-white/10 bg-eb-bg p-3 text-center">
          <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">{b.label}</span>
          <p className="mt-1 font-heading text-lg text-white">
            {b.wins}-{b.losses}-{b.pushes}
          </p>
          <p className={`font-mono text-xs ${b.win_pct !== null ? RESULT_STYLE.WIN : RESULT_STYLE.PENDING}`}>
            {b.win_pct !== null ? `${b.win_pct}%` : "No graded picks"}
          </p>
        </div>
      ))}
    </div>
  </div>
);

// NRFI/YRFI buckets are kept fully separate from Full Game/F5 -- and from each other -- so
// their forward-testing performance is never mixed with the O/U markets.
export const ProbabilityBuckets = ({ buckets, sectionId = "probability-buckets" }) => (
  <div data-testid={sectionId} className="flex flex-col gap-4 rounded-lg border border-white/10 bg-eb-surface p-4">
    <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">Performance By Model Confidence Bucket</span>
    {GROUPS.map(({ key, label, experimental }) => (
      <BucketGroup key={key} label={label} buckets={buckets[key] || []} testId={`${sectionId}-${key}`} experimental={experimental} />
    ))}
    <p className="font-mono text-[10px] text-zinc-600">
      58% remains the official Largest Leans threshold until manually changed. This section only shows historical performance by
      bucket -- it never auto-adjusts the threshold.
    </p>
  </div>
);
